import '../styles/ContactPanelStage.css';
import React from 'react';
import { useProjectCollection } from '../lib/projectData';

const CONTACT_CHANNELS = [
  {
    key: 'email',
    label: 'Email',
    value: 'umangsuthar97@gmail.com',
    href: 'mailto:umangsuthar97@gmail.com',
    external: false,
    hint: 'Opens your mail client',
  },
  {
    key: 'twitter',
    label: 'Twitter',
    value: '@umangsuthar97',
    href: 'https://twitter.com/umangsuthar97',
    external: true,
    hint: 'Opens the Twitter profile',
  },
  {
    key: 'github',
    label: 'GitHub',
    value: 'github.com/umangsuthar',
    href: 'https://github.com/umangsuthar',
    external: true,
    hint: 'Opens the GitHub profile',
  },
];

/* Published fallbacks — shown while the profiles collection loads or is unavailable. */
const OWNER_FALLBACK = {
  name: 'Umang Suthar',
  displayName: 'UMANG SUTHAR',
  title: 'FULL STACK DEVELOPER',
};

function ContactPanelStage() {
  const { data } = useProjectCollection('profiles');
  const profile = Array.isArray(data) && data.length > 0 ? data[0] : null;

  const ownerName = (profile && profile.name) || OWNER_FALLBACK.name;
  const ownerTitle = (profile && profile.title) || OWNER_FALLBACK.title;

  return (
    <section className="cps-stage" aria-labelledby="cps-marker">
      <svg
        className="cps-sweep"
        viewBox="0 0 1440 240"
        preserveAspectRatio="none"
        aria-hidden="true"
        focusable="false"
      >
        <path className="cps-sweep__pearl" d="M0,120 Q720,0 1440,120" pathLength="1" />
        <path className="cps-sweep__gold" d="M0,120 Q720,0 1440,120" pathLength="1" />
      </svg>
      <span className="cps-sweep__marker" aria-hidden="true">marine-portfolio</span>

      <div className="cps-rail" data-content-rail="primary">
        <div className="cps-panel-measure">
          <div className="cps-panel">
            <div className="cps-panel__head">
              <h1 className="cps-marker" id="cps-marker">Contact</h1>
              <div className="cps-owner">
                <p className="cps-owner__name">{ownerName}</p>
                <p className="cps-owner__title">{ownerTitle}</p>
                <span className="cps-owner__rule" aria-hidden="true" />
              </div>
            </div>

            <ul className="cps-rows">
              {CONTACT_CHANNELS.map((channel) => (
                <li className="cps-row" key={channel.key}>
                  <a
                    className="cps-row__link"
                    href={channel.href}
                    rel={channel.external ? 'noopener noreferrer' : undefined}
                    target={channel.external ? '_blank' : undefined}
                  >
                    <span className="cps-row__label">{channel.label}</span>
                    <span className="cps-row__value">
                      {channel.value}
                      <span className="cps-row__ext" aria-hidden="true">
                        {channel.external ? '↗' : '→'}
                      </span>
                      <span className="cps-row__rule" aria-hidden="true" />
                    </span>
                    <span className="sr-only-cps">{channel.hint}</span>
                  </a>
                </li>
              ))}
            </ul>

            <div className="cps-return">
              <a className="cps-return__link" href="/portfolio">
                <span className="cps-return__arrow" aria-hidden="true">←</span>
                <span>Return to Portfolio</span>
              </a>
              <p className="cps-return__note">Portfolio · Education · Languages</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactPanelStage;